import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "@/lib/site";
import { trackClick } from "@/lib/track";

export const CtaButton = ({ testId, placement, product = "joint-genesis", children = "Visit the official site", variant = "solid", className = "" }) => {
  const base = "group inline-flex items-center gap-3 rounded-full px-6 py-3.5 text-sm font-semibold transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 active:translate-y-0";
  const styles = variant === "crimson"
    ? "bg-[#FF4D4D] text-[#140A0C] hover:bg-[#F2EDE4]"
    : variant === "sky"
    ? "bg-[#00AEEF] text-[#071E33] hover:bg-[#F2EDE4]"
    : variant === "solid"
    ? "bg-[#D96B43] text-[#0C1F1B] hover:bg-[#F2EDE4]"
    : "border border-[#F2EDE4]/30 text-[#F2EDE4] hover:bg-[#F2EDE4] hover:text-[#091D18]";
  return (
    <a href={PRODUCTS[product].hoplink} target="_blank" rel="sponsored noopener noreferrer" data-testid={testId} onClick={() => trackClick(placement, product)} className={`${base} ${styles} ${className}`}>
      {children}
      <span className="grid h-7 w-7 place-items-center rounded-full bg-[#091D18] text-[#F2EDE4] transition-transform duration-300 group-hover:rotate-45">
        <ArrowUpRight className="h-4 w-4" />
      </span>
    </a>
  );
};
